
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTeam = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 53,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.006 11.259-.855.616 1.002.329c1.937.635 3.269 2.275 3.269 4.145v11.18H5.455v-11.18c0-1.87 1.332-3.51 3.268-4.145l1.003-.329-.856-.616c-.567-.41-.906-1.013-.906-1.67v-.9c0-1.143 1.054-2.168 2.474-2.168s2.475 1.025 2.475 2.167v.901c0 .653-.34 1.261-.907 1.67Zm10.422 0-.855.616 1.002.329c1.937.635 3.269 2.275 3.269 4.145v11.18h-9.968v-11.18c0-1.87 1.333-3.51 3.27-4.145l1.002-.329-.856-.616c-.567-.41-.906-1.013-.906-1.67v-.9c0-1.143 1.054-2.168 2.474-2.168s2.474 1.025 2.474 2.167v.901c0 .653-.34 1.261-.906 1.67Z",
  stroke: "#000",
  strokeWidth: 1.073
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.668 20.06-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.854.777H1.427c-.5 0-.855-.38-.855-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.522-.397-.843-.99-.843-1.643v-.9c0-1.142.992-2.125 2.28-2.125 1.29 0 2.282.983 2.282 2.125v.9c0 .65-.322 1.247-.844 1.643Zm9.848 0-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.854.777h-7.609c-.5 0-.854-.38-.854-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.523-.397-.844-.99-.844-1.643v-.9c0-1.142.993-2.125 2.281-2.125 1.29 0 2.282.983 2.282 2.125v.9c0 .65-.322 1.247-.844 1.643Zm9.844 0-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.855.777h-7.608c-.5 0-.854-.38-.854-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.523-.397-.844-.99-.844-1.643v-.9c0-1.142.992-2.125 2.281-2.125s2.281.983 2.281 2.125v.9c0 .65-.321 1.247-.843 1.643Z",
  fill: "var(--theme-light, #f9f3fb)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.144
})));

      const __svgRaw = "<svg width=\"52\" height=\"53\" viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"m12.006 11.259-.855.616 1.002.329c1.937.635 3.269 2.275 3.269 4.145v11.18H5.455v-11.18c0-1.87 1.332-3.51 3.268-4.145l1.003-.329-.856-.616c-.567-.41-.906-1.013-.906-1.67v-.9c0-1.143 1.054-2.168 2.474-2.168s2.475 1.025 2.475 2.167v.901c0 .653-.34 1.261-.907 1.67Zm10.422 0-.855.616 1.002.329c1.937.635 3.269 2.275 3.269 4.145v11.18h-9.968v-11.18c0-1.87 1.333-3.51 3.27-4.145l1.002-.329-.856-.616c-.567-.41-.906-1.013-.906-1.67v-.9c0-1.143 1.054-2.168 2.474-2.168s2.474 1.025 2.474 2.167v.901c0 .653-.34 1.261-.906 1.67Z\" stroke=\"#000000\" stroke-width=\"1.073\"/><path d=\"m6.668 20.06-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.854.777H1.427c-.5 0-.855-.38-.855-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.522-.397-.843-.99-.843-1.643v-.9c0-1.142.992-2.125 2.28-2.125 1.29 0 2.282.983 2.282 2.125v.9c0 .65-.322 1.247-.844 1.643Zm9.848 0-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.854.777h-7.609c-.5 0-.854-.38-.854-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.523-.397-.844-.99-.844-1.643v-.9c0-1.142.993-2.125 2.281-2.125 1.29 0 2.282.983 2.282 2.125v.9c0 .65-.322 1.247-.844 1.643Zm9.844 0-.853.647 1.012.35c1.802.621 3.062 2.237 3.062 4.102v2.697c0 .396-.355.777-.855.777h-7.608c-.5 0-.854-.38-.854-.777V25.16c0-1.865 1.26-3.48 3.062-4.102l1.012-.35-.853-.647c-.523-.397-.844-.99-.844-1.643v-.9c0-1.142.992-2.125 2.281-2.125s2.281.983 2.281 2.125v.9c0 .65-.321 1.247-.843 1.643Z\" fill=\"var(--theme-light, #f9f3fb)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.144\"/>  \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/team.c98721c2b2f8c120268bee5bc1910d79.svg"),
        {
          React: SvgTeam,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      